import React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface BasicWorkspace {
    id: string;
    name: string;
}

interface WorkspaceSelectorProps {
    workspaces: BasicWorkspace[];
    selectedWorkspaceId: string | null;
    onChange: (workspaceId: string) => void;
}

// Styled components
const SelectorContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    padding: `${theme.spacing(1)} ${theme.spacing(6)}`,
    margin: `0 0 ${theme.spacing(2)} 0`,
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
        display: 'none'
    },
}));

const WorkspaceButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '39px',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: '50px',
    border: `1px solid ${isSelected ? theme.palette.primary.main : 'rgba(255,255,255,0.66)'}`,
    backgroundColor: isSelected ? theme.palette.primary.main : 'transparent',
    color: 'white',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    flex: "0 0 auto",
    minWidth: "fit-content",
    // Hover styling ONLY where a pointer can actually hover. On touch, :hover
    // sticks to the last element tapped, so an UNSELECTED workspace kept the
    // selected chip's blue after a tap — two chips looking active at once, and
    // the highlight no longer telling the truth about which one is loaded.
    '@media (hover: hover)': {
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: isSelected ? theme.palette.primary.dark : theme.palette.primary.main,
        },
    },
}));

const TeamIcon = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    backgroundColor: 'white',
    borderRadius: '50%',
    color: theme.palette.primary.main,
    fontSize: '14px'
}));

const WorkspaceSelector: React.FC<WorkspaceSelectorProps> = ({
                                                                 workspaces,
                                                                 selectedWorkspaceId,
                                                                 onChange
                                                             }) => {
    if (!workspaces || workspaces.length <= 1) return null;

    return (
        <SelectorContainer>
            {workspaces.map((workspace) => (
                <WorkspaceButton
                    key={workspace.id}
                    isSelected={workspace.id === selectedWorkspaceId}
                    onClick={() => onChange(workspace.id)}
                >
                    {/*<TeamIcon>🏀</TeamIcon>*/}
                    {workspace.name}
                </WorkspaceButton>
            ))}
        </SelectorContainer>
    );
};

export default WorkspaceSelector;